import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "#5f6a7d",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M7.333 2.667a4.667 4.667 0 0 0 0 9.333.667.667 0 1 1 0 1.334 6 6 0 0 1 0-12 .667.667 0 1 1 0 1.333",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M6.667 2c0-.368.298-.667.666-.667a6 6 0 0 1 4.688 9.746l2.45 2.45a.667.667 0 0 1-.942.943l-2.45-2.45a5.97 5.97 0 0 1-3.746 1.312.667.667 0 0 1 0-1.334 4.65 4.65 0 0 0 3.238-1.306.7.7 0 0 1 .123-.123 4.667 4.667 0 0 0-3.36-7.904A.667.667 0 0 1 6.666 2",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }